(() => {
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
  const body = document.body;
  const scrim = $('[data-close-panels]');
  const cartDrawer = $('#CartDrawer');
  const searchOverlay = $('#SearchOverlay');
  const mobileMenu = $('#MobileMenu');
  const megaMenu = $('#MegaMenu');
  const megaTrigger = $('[data-open-mega]');
  const siteHeader = $('[data-header]');

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency', currency: 'USD'
      }).format(cents / 100);
    } catch (_) {
      return `$${(cents / 100).toFixed(2)}`;
    }
  }

  function showScrim() {
    if (!scrim) return;
    scrim.hidden = false;
    body.classList.add('panel-open');
  }

  function closePanels() {
    [cartDrawer, mobileMenu, megaMenu].forEach((panel) => panel?.classList.remove('is-open'));
    siteHeader?.classList.remove('is-expanded');
    if (cartDrawer) cartDrawer.setAttribute('aria-hidden', 'true');
    if (mobileMenu) mobileMenu.setAttribute('aria-hidden', 'true');
    if (megaMenu) megaMenu.setAttribute('aria-hidden', 'true');
    megaTrigger?.setAttribute('aria-expanded', 'false');
    if (searchOverlay) {
      searchOverlay.hidden = true;
      searchOverlay.setAttribute('aria-hidden', 'true');
    }
    if (scrim) scrim.hidden = true;
    body.classList.remove('panel-open');
  }

  function openCart() {
    closePanels();
    cartDrawer?.classList.add('is-open');
    cartDrawer?.setAttribute('aria-hidden', 'false');
    showScrim();
  }

  function openMobileMenu() {
    closePanels();
    mobileMenu?.classList.add('is-open');
    mobileMenu?.setAttribute('aria-hidden', 'false');
    showScrim();
  }

  function openSearch() {
    closePanels();
    if (!searchOverlay) return;
    searchOverlay.hidden = false;
    searchOverlay.setAttribute('aria-hidden', 'false');
    body.classList.add('panel-open');
    setTimeout(() => $('#OverlaySearch')?.focus(), 60);
  }

  $$('[data-open-cart]').forEach((el) => el.addEventListener('click', openCart));
  $$('[data-close-cart], [data-close-overlay], [data-close-mobile], [data-close-mega]').forEach((el) => el.addEventListener('click', closePanels));
  $$('[data-open-mobile]').forEach((el) => el.addEventListener('click', openMobileMenu));
  $$('[data-open-search]').forEach((el) => el.addEventListener('click', openSearch));
  scrim?.addEventListener('click', closePanels);
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closePanels(); });

  megaTrigger?.addEventListener('click', () => {
    const willOpen = !megaMenu?.classList.contains('is-open');
    closePanels();
    if (willOpen && megaMenu) {
      siteHeader?.classList.add('is-expanded');
      megaMenu.classList.add('is-open');
      megaMenu.setAttribute('aria-hidden', 'false');
      megaTrigger.setAttribute('aria-expanded', 'true');
    }
  });

  $$('[data-filter-toggle]').forEach((button) => {
    button.addEventListener('click', () => $('#CollectionLayout')?.classList.toggle('filters-open'));
  });

  $$('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.assign(url.toString());
    });
  });

  function initImageDuos(context = document) {
    $$('[data-image-duo]', context).forEach((duo) => {
      if (duo.dataset.interactiveReady === 'true') return;
      duo.dataset.interactiveReady = 'true';
      const panels = $$('[data-duo-panel]', duo);
      const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      panels.forEach((panel) => {
        const select = $('[data-duo-select]', panel);
        if (!select) return;

        if (canHover) {
          panel.addEventListener('pointerenter', () => {
            if (duo.classList.contains('has-active')) return;
            panels.forEach((item) => item.classList.toggle('is-preview', item === panel));
            duo.classList.add('has-preview');
          });
          panel.addEventListener('pointerleave', () => {
            if (duo.classList.contains('has-active')) return;
            panel.classList.remove('is-preview');
            duo.classList.remove('has-preview');
          });
        }

        select.addEventListener('click', () => {
          if (panel.classList.contains('is-active') && select.dataset.duoLink) {
            window.location.assign(select.dataset.duoLink);
            return;
          }
          const willOpen = !panel.classList.contains('is-active');
          duo.classList.remove('has-preview');
          panels.forEach((item) => {
            const isActive = item === panel && willOpen;
            item.classList.remove('is-preview');
            item.classList.toggle('is-active', isActive);
            $('[data-duo-select]', item)?.setAttribute('aria-expanded', String(isActive));
          });
          duo.classList.toggle('has-active', willOpen);
        });
      });
    });
  }

  initImageDuos();
  document.addEventListener('shopify:section:load', (event) => initImageDuos(event.target));

  function initEditorialQuartets(context = document) {
    $$('.editorial-quartet', context).forEach((quartet) => {
      if (quartet.dataset.touchReady === 'true') return;
      quartet.dataset.touchReady = 'true';
      const isTouchLayout = window.matchMedia('(max-width: 640px), (hover: none), (pointer: coarse)').matches;
      if (!isTouchLayout) return;

      const tiles = $$('.editorial-tile', quartet);
      tiles.forEach((tile) => {
        tile.setAttribute('aria-expanded', 'false');
        tile.addEventListener('click', (event) => {
          if (tile.classList.contains('is-active')) return;
          event.preventDefault();
          tiles.forEach((item) => {
            const isActive = item === tile;
            item.classList.toggle('is-active', isActive);
            item.setAttribute('aria-expanded', String(isActive));
          });
          quartet.classList.add('has-active');
          tile.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        });
      });
    });
  }

  initEditorialQuartets();
  document.addEventListener('shopify:section:load', (event) => initEditorialQuartets(event.target));

  async function fetchCart() {
    const response = await fetch(`${window.eravineTheme.routes.cart}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  function updateCart(cart) {
    $$('[data-cart-count]').forEach((count) => { count.textContent = `(${cart.item_count})`; });
    const items = $('[data-cart-items]');
    const footer = $('[data-cart-footer]');
    const total = $('[data-cart-total]');
    const shipping = $('[data-shipping-message]');
    const progress = $('[data-shipping-progress]');
    if (total) total.textContent = formatMoney(cart.total_price);
    if (shipping) {
      const left = Math.max(0, window.eravineTheme.freeShippingThreshold - cart.total_price);
      shipping.textContent = left > 0 ? `You’re ${formatMoney(left)} away from complimentary delivery.` : 'Complimentary delivery unlocked.';
    }
    if (progress) progress.style.width = `${Math.min(100, cart.total_price / window.eravineTheme.freeShippingThreshold * 100)}%`;
    if (!items) return;
    if (!cart.items.length) {
      items.innerHTML = '<div class="empty-state"><p>Your bag is empty.</p><a href="/collections/all" class="button button--light">Discover the collection</a></div>';
      footer?.classList.add('is-empty');
      return;
    }
    footer?.classList.remove('is-empty');
    items.innerHTML = cart.items.map((item, index) => `
      <div class="drawer-item" data-line="${index + 1}">
        <a href="${item.url}" class="drawer-item__image"><img src="${item.featured_image?.url || ''}" alt="${escapeHtml(item.product_title)}" width="240" height="320"></a>
        <div class="drawer-item__copy">
          <a href="${item.url}">${escapeHtml(item.product_title)}</a>
          ${item.variant_title ? `<small>${escapeHtml(item.variant_title)}</small>` : ''}
          <div>${formatMoney(item.final_line_price)}</div>
          <button type="button" class="text-link text-link--muted" data-remove-line="${index + 1}">Remove</button>
        </div>
      </div>`).join('');
    bindRemoveButtons();
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value || '';
    return div.innerHTML;
  }

  async function changeLine(line, quantity) {
    const response = await fetch(`${window.eravineTheme.routes.cartChange}.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity })
    });
    if (!response.ok) throw new Error('Unable to update bag');
    updateCart(await response.json());
  }

  function bindRemoveButtons() {
    $$('[data-remove-line]').forEach((button) => {
      button.onclick = () => changeLine(Number(button.dataset.removeLine), 0).catch(console.error);
    });
  }
  bindRemoveButtons();

  $$('.product-form').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      if (!window.fetch || form.dataset.noAjax === 'true') return;
      event.preventDefault();
      const submit = $('[type="submit"]', form);
      const originalText = submit?.textContent;
      if (submit) { submit.disabled = true; submit.textContent = 'Adding…'; }
      try {
        const response = await fetch(`${window.eravineTheme.routes.cartAdd}.js`, {
          method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
        });
        if (!response.ok) throw new Error('This item could not be added.');
        updateCart(await fetchCart());
        openCart();
      } catch (error) {
        alert(error.message);
      } finally {
        if (submit) { submit.disabled = false; submit.textContent = originalText; }
      }
    });
  });
})();
